import { render, staticRenderFns } from "./RowInfo.vue?vue&type=template&id=60f8cc89&scoped=true&"
import script from "./RowInfo.vue?vue&type=script&lang=js&"
export * from "./RowInfo.vue?vue&type=script&lang=js&"
import style0 from "./RowInfo.vue?vue&type=style&index=0&id=60f8cc89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8cc89",
  null
  
)

export default component.exports